import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { ChipModule } from 'primeng/chip';
import { InputTextModule } from 'primeng/inputtext';
import { I18nModule, TranslationService } from '../../../i18n';
import { CplaceControlSkeletonModule } from '../cplace-control-skeleton';
import { CplaceControlService } from '../shared';
import { CplaceSingleReferenceControlComponent } from './cplace-single-reference-control.component';
import * as de from './lang/de.json';
import * as en from './lang/en.json';

@NgModule({
  declarations: [CplaceSingleReferenceControlComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    I18nModule,
    CplaceControlSkeletonModule,
    InputTextModule,
    ChipModule,
    AutoCompleteModule,
    ButtonModule,
  ],
  exports: [CplaceSingleReferenceControlComponent],
  providers: [CplaceControlService],
})
export class CplaceSingleReferenceControlModule {
  constructor(private translationService: TranslationService) {
    this.translationService.addTranslation({
      translations: {
        en: en,
        de: de,
      },
    });
  }
}
